import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { gsap } from 'gsap'

import { Raycaster } from 'three'


const debugObject = {}

/**
 * Loaders
 */
 let sceneReady = false
 const loadingBarElement = document.querySelector('.loading-bar')
 const loadingManager = new THREE.LoadingManager(
     // Loaded
     () =>
     {
         // Wait a little
         window.setTimeout(() =>
         {
            const loadingScreen = document.getElementById( 'loading-screen' );
            loadingScreen.classList.add( 'fade-out' );

             // optional: remove loader from DOM via event listener
     loadingScreen.addEventListener( 'transitionend', onTransitionEnd );

        
             // Update loadingBarElement
             loadingBarElement.classList.add('ended')
             loadingBarElement.style.transform = ''
         }, 500)
 
         window.setTimeout(( )=>
         {
                 sceneReady = true
         }, 2000 )
     },
 
     // Progress
     (itemUrl, itemsLoaded, itemsTotal) =>
     {
         // Calculate the progress and update the loadingBarElement
         const progressRatio = itemsLoaded / itemsTotal
         loadingBarElement.style.transform = `scaleX(${progressRatio})`
     }
 )
const gltfLoader = new GLTFLoader(loadingManager)
const cubeTextureLoader = new THREE.CubeTextureLoader(loadingManager)


/**
 *  Textures
 */
const textureLoader = new THREE.TextureLoader()

const floorAlpha = textureLoader.load('/textures/CircularAlpha.jpg')




/**
 * Base
 */


// Canvas
const canvas = document.querySelector('canvas.webgl')


// Scene
const scene = new THREE.Scene()



/**
 * Update all materials
 */
const updateAllMaterials = () =>
{
    scene.traverse((child) =>
    {
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        {
            child.material.envMap = environmentMap
            child.material.envMapIntensity = debugObject.envMapIntensity
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true
        }
    })
}


  
/**
 *  Objects
 */
 
 const FloorMaterial = new THREE.MeshStandardMaterial( )
 FloorMaterial.opacity = 0.5
 FloorMaterial.transparent = true
 
 FloorMaterial.alphaMap = floorAlpha

 const Floor = new THREE.Mesh( 
     new THREE.PlaneBufferGeometry(10, 10),
      FloorMaterial )
 Floor.rotation.x =- Math.PI * 0.5
 Floor.position.y = - 2.001
 
 scene.add( Floor )


/**
 * Environment map
 */
const environmentMap = cubeTextureLoader.load([
    '/textures/environmentMaps/0/px.jpg',
    '/textures/environmentMaps/0/nx.jpg',
    '/textures/environmentMaps/0/py.jpg',
    '/textures/environmentMaps/0/ny.jpg',
    '/textures/environmentMaps/0/pz.jpg',
    '/textures/environmentMaps/0/nz.jpg'
])

environmentMap.encoding = THREE.sRGBEncoding

//scene.background = environmentMap
scene.environment = environmentMap

debugObject.envMapIntensity = 5


/**
 * Models
 */
gltfLoader.load(
    '/models/RTMEV/EVCharger_RTMEVChargerEXP.gltf',
    (gltf) =>
    {
       
        gltf.scene.scale.set(2.5, 2.5, 2.5)
        gltf.scene.position.set(0, -2, 0)
        gltf.scene.rotation.y = Math.PI * -1
        scene.add(gltf.scene)

        updateAllMaterials()
    }
)

/**
 * Points of Interest
 */
const raycaster = new Raycaster()
const points = [
    {
        position: new THREE.Vector3(0.45, 1, -0.65),
        element: document.querySelector(' .point-0')
    },
    {
        position: new THREE.Vector3(-0.5, 0.75, -0.75),
        element: document.querySelector(' .point-1')
    },
    {
        position: new THREE.Vector3(0, 2, -0.65),
        element: document.querySelector(' .point-2')
    }
]


/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 4)
directionalLight.castShadow = true
directionalLight.shadow.camera.far = 10
directionalLight.shadow.mapSize.set(2048, 2048)
directionalLight.shadow.normalBias = 0.05
directionalLight.position.set(2.14, 4.52, 1.6)
scene.add(directionalLight)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Mouse
 */
 const mouse = new THREE.Vector2()
 window.addEventListener('mousemove', (event ) =>
 {
     mouse.x = event.clientX / sizes.width * 2 -1
     mouse.y = - (event.clientY / sizes.height * 2 -1)
 })
 
 window.addEventListener('click', ( )=>
 {
    if(currentIntersect)
    {
        console.log('click on a sphere')
    }
 })
 
/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(-2.5, 1.5,  -5.5)
scene.add(camera)



// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.maxPolarAngle = Math.PI * 0.49
controls.panSpeed  = 0
controls.zoomSpeed  = 0
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    alpha: true
})
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1.5

renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


function onTransitionEnd( event ) {

	event.target.remove();
	
}

/**
 * Animate
 */
const tick = () =>
{
    // Update controls
    controls.update()

    if (sceneReady)
    {
 // Go through each point
 for(const point of points)
 {
     const screenPosition = point.position.clone()
     screenPosition.project(camera)

     raycaster.setFromCamera(screenPosition, camera)
     const intersects = raycaster.intersectObjects(scene.children, true)

     if(intersects.length === 0)
     {
         point.element.classList.add('visible')
     }
     else
     {
         const intersectionDistance = intersects[0].distance
         const pointDistance = point.position.distanceTo(camera.position)

         if(intersectionDistance < pointDistance)
         {
             point.element.classList.remove('visible')
         }
         else
         {
             point.element.classList.add('visible')
         }
         //point.element.classList.remove('visible')
     }
     const translateX = screenPosition.x * sizes.width * 0.5
     const translateY = - screenPosition.y * sizes.height * 0.5
     point.element.style.transform = `translate(${translateX}px, ${translateY}px)`
 }
    }
   

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

